/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Icsrm_Pedagogy13Inputs */

const en__field_enum_icsrm_pedagogy13 = /** @type {(inputs: _Field_Enum_Icsrm_Pedagogy13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teaching & Pedagogy`)
};

const de__field_enum_icsrm_pedagogy13 = /** @type {(inputs: _Field_Enum_Icsrm_Pedagogy13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lehramt & Pädagogik`)
};

/**
* | output |
* | --- |
* | "Teaching & Pedagogy" |
*
* @param {_Field_Enum_Icsrm_Pedagogy13Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_icsrm_pedagogy13 = /** @type {((inputs?: _Field_Enum_Icsrm_Pedagogy13Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Icsrm_Pedagogy13Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_icsrm_pedagogy13(inputs)
	return de__field_enum_icsrm_pedagogy13(inputs)
});
export { _field_enum_icsrm_pedagogy13 as "_field_enum_ICSRM_PEDAGOGY" }